/**
 * Parse DetectiveHireRequested event from transaction receipt
 */
import { field } from "./viem";

export const parseDetectiveHireRequestedEvent = (event: any) => {
  return {
    hireId: Number(field(event.returnValues, "hireId", 0)),
    user: field(event.returnValues, "user", 2),
    target: field(event.returnValues, "target", 3),
    detectivesCount: Number(field(event.returnValues, "detectivesCount", 4)),
    timestamp: Number(field(event.returnValues, "timestamp", 7)),
  };
};

/**
 * Parse DetectiveHireFinished event from transaction receipt
 */
export const parseDetectiveHireFinishedEvent = (event: any) => {
  return {
    hireId: Number(field(event.returnValues, "hireId", 0)),
    targetNumber: Number(field(event.returnValues, "targetNumber", 1)),
    isTargetFound: Boolean(field(event.returnValues, "isTargetFound", 2)),
    timestamp: Number(field(event.returnValues, "timestamp", 3)),
  };
};

export const parseDetectiveTargetRevealedEvent = (event: any) => {
  return {
    hireId: Number(field(event.returnValues, "hireId", 0)),
    user: field(event.returnValues, "user", 1),
    target: field(event.returnValues, "target", 2),
    targetCityId: Number(field(event.returnValues, "targetCityId", 3)),
    canKillUntilTime: Number(field(event.returnValues, "canKillUntilTime", 4)),
    timestamp: Number(field(event.returnValues, "timestamp", 5)),
  };
};
